// import React from "react";
// import { motion } from "framer-motion";
// import {
//   Server,
//   Shield,
//   Cpu,
//   Headphones,
//   Cable,
//   Video,
//   AlertTriangle,
//   Settings,
//   Cloud,
// } from "lucide-react";

// const servicesData = [
//   {
//     category: "Network & Communication Solutions",
//     items: [
//       {
//         icon: <Cpu className="w-8 h-8 text-yellow-400" />,
//         title: "LAN, WAN & Wireless Solutions",
//         desc: "High-performance network design and deployment for business-critical operations.",
//       },
//       {
//         icon: <Settings className="w-8 h-8 text-yellow-400" />,
//         title: "Unified Communications & Collaboration",
//         desc: "Voice, video, and messaging solutions for seamless connectivity.",
//       },
//       {
//         icon: <Video className="w-8 h-8 text-yellow-400" />,
//         title: "VOIP & Video-over-IP Solutions",
//         desc: "Flexible communication platforms for modern organizations.",
//       },
//     ],
//   },
//   {
//     category: "Data Center & Storage Solutions",
//     items: [
//       {
//         icon: <Server className="w-8 h-8 text-yellow-400" />,
//         title: "Data Center Infrastructure",
//         desc: "Design, installation, and optimization of data center environments.",
//       },
//       {
//         icon: <Cloud className="w-8 h-8 text-yellow-400" />,
//         title: "Enterprise Servers & Storage",
//         desc: "Scalable, secure storage and processing solutions.",
//       },
//       {
//         icon: <AlertTriangle className="w-8 h-8 text-yellow-400" />,
//         title: "Backup & Disaster Recovery Systems",
//         desc: "Safeguarding critical data with reliable recovery strategies.",
//       },
//     ],
//   },
//   {
//     category: "Managed Services & Support",
//     items: [
//       {
//         icon: <Shield className="w-8 h-8 text-yellow-400" />,
//         title: "Preventive & Corrective Maintenance",
//         desc: "On-demand and scheduled service for under-warranty and non-warranty systems.",
//       },
//       {
//         icon: <Headphones className="w-8 h-8 text-yellow-400" />,
//         title: "Training & After-Sales Support",
//         desc: "Empowering clients to maximize the use and efficiency of their systems.",
//       },
//       {
//         icon: <Shield className="w-8 h-8 text-yellow-400" />,
//         title: "Extended Warranty & Service Contracts",
//         desc: "Peace of mind with long-term protection plans.",
//       },
//     ],
//   },
//   {
//     category: "Infrastructure Solutions",
//     items: [
//       {
//         icon: <Cable className="w-8 h-8 text-yellow-400" />,
//         title: "Low Current Systems",
//         desc: "Design, supply, and installation of structured cabling, copper and fiber networks, and intelligent infrastructure.",
//       },
//       {
//         icon: <Cable className="w-8 h-8 text-yellow-400" />,
//         title: "FTTH & Outside Plant (OSP) Solutions",
//         desc: "End-to-end fiber network deployment, from survey and design to installation and testing.",
//       },
//       {
//         icon: <Settings className="w-8 h-8 text-yellow-400" />,
//         title: "Electrical Systems",
//         desc: "Turnkey electrical projects for large-scale facilities and organizations.",
//       },
//     ],
//   },
//   {
//     category: "Security & Safety Solutions",
//     items: [
//       {
//         icon: <Video className="w-8 h-8 text-yellow-400" />,
//         title: "CCTV & Surveillance Systems",
//         desc: "Advanced video monitoring for enhanced safety and operational visibility.",
//       },
//       {
//         icon: <Shield className="w-8 h-8 text-yellow-400" />,
//         title: "Access Control Systems",
//         desc: "Secure and manage entry to facilities with reliable, scalable solutions.",
//       },
//       {
//         icon: <AlertTriangle className="w-8 h-8 text-yellow-400" />,
//         title: "Fire Alarm & Public Address Systems",
//         desc: "Integrated safety systems for emergency response and public communication.",
//       },
//     ],
//   },
// ];

// export default function Services() {
//   return (
//     <div className="bg-black text-white py-16 px-6 md:px-20">
//       <motion.h1
//         initial={{ opacity: 0, y: -30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.8 }}
//         className="text-4xl font-bold text-center mb-12"
//       >
//         <span className="bg-yellow-400 text-black px-4 py-2 rounded-lg shadow-md">
//           Our Services & Solutions
//         </span>
//       </motion.h1>

//       <div className="space-y-16">
//         {servicesData.map((section, i) => (
//           <motion.div
//             key={i}
//             initial={{ opacity: 0, y: 40 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8, delay: i * 0.2 }}
//             viewport={{ once: true }}
//           >
//             <h2 className="text-2xl font-semibold mb-6 border-l-4 border-yellow-400 pl-3">
//               {section.category}
//             </h2>
//             <div className="grid md:grid-cols-3 gap-6">
//               {section.items.map((item, j) => (
//                 <motion.div
//                   key={j}
//                   whileHover={{ scale: 1.05 }}
//                   className="bg-[#201C59] rounded-2xl p-6 shadow-lg flex flex-col gap-4"
//                 >
//                   {item.icon}
//                   <h3 className="text-lg font-bold">{item.title}</h3>
//                   <p className="text-gray-200">{item.desc}</p>
//                 </motion.div>
//               ))}
//             </div>
//           </motion.div>
//         ))}
//       </div>
//     </div>
//   );
// }


import React from "react";
import { motion } from "framer-motion";
import {
  ServerIcon,
  ShieldCheckIcon,
  CpuChipIcon,
  PhoneIcon,
  VideoCameraIcon,
  CloudIcon,
  WrenchIcon,
  AcademicCapIcon,
  BoltIcon,
  BuildingLibraryIcon,
  KeyIcon,
  BellAlertIcon,
} from "@heroicons/react/24/outline";

const GradientIcon = ({ Icon }) => (
  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-r from-yellow-400 to-[#201C59]">
    <Icon className="w-6 h-6 text-white" />
  </div>
);

const servicesData = [
  
  {
    category: "Data Center & Storage Solutions",
    items: [
      {
        icon: <GradientIcon Icon={ServerIcon} />,
        title: "Data Center Infrastructure",
        desc: "Design, installation, and optimization of data center environments.",
      },
      {
        icon: <GradientIcon Icon={CloudIcon} />,
        title: "Enterprise Servers & Storage",
        desc: "Scalable, secure storage and processing solutions.",
      },
      {
        icon: <GradientIcon Icon={ShieldCheckIcon} />,
        title: "Backup & Disaster Recovery Systems",
        desc: "Safeguarding critical data with reliable recovery strategies.",
      },
    ],
  },
  {
    category: "Managed Services & Support",
    items: [
      {
        icon: <GradientIcon Icon={WrenchIcon} />,
        title: "Preventive & Corrective Maintenance",
        desc: "On-demand and scheduled service for under-warranty and non-warranty systems.",
      },
      {
        icon: <GradientIcon Icon={AcademicCapIcon} />,
        title: "Training & After-Sales Support",
        desc: "Empowering clients to maximize the use and efficiency of their systems.",
      },
      {
        icon: <GradientIcon Icon={ShieldCheckIcon} />,
        title: "Extended Warranty & Service Contracts",
        desc: "Peace of mind with long-term protection plans.",
      },
    ],
  },
  {
    category: "Infrastructure Solutions",
    items: [
      {
        icon: <GradientIcon Icon={BoltIcon} />,
        title: "Low Current Systems",
        desc: "Design, supply, and installation of structured cabling, copper and fiber networks, and intelligent infrastructure.",
      },
      {
        icon: <GradientIcon Icon={BuildingLibraryIcon} />,
        title: "FTTH & Outside Plant (OSP) Solutions",
        desc: "End-to-end fiber network deployment, from survey and design to installation and testing.",
      },
      {
        icon: <GradientIcon Icon={BoltIcon} />,
        title: "Electrical Systems",
        desc: "Turnkey electrical projects for large-scale facilities and organizations.",
      },
    ],
  },
  {
    category: "Network & Communication Solutions",
    items: [
      {
        icon: <GradientIcon Icon={CpuChipIcon} />,
        title: "LAN, WAN & Wireless Solutions",
        desc: "High-performance network design and deployment for business-critical operations.",
      },
      {
        icon: <GradientIcon Icon={PhoneIcon} />,
        title: "Unified Communications & Collaboration",
        desc: "Voice, video, and messaging solutions for seamless connectivity.",
      },
      {
        icon: <GradientIcon Icon={VideoCameraIcon} />,
        title: "VOIP & Video-over-IP Solutions",
        desc: "Flexible communication platforms for modern organizations.",
      },
    ],
  },
  {
    category: "Security & Safety Solutions",
    items: [
      {
        icon: <GradientIcon Icon={VideoCameraIcon} />,
        title: "CCTV & Surveillance Systems",
        desc: "Advanced video monitoring for enhanced safety and operational visibility.",
      },
      {
        icon: <GradientIcon Icon={KeyIcon} />,
        title: "Access Control Systems",
        desc: "Secure and manage entry to facilities with reliable, scalable solutions.",
      },
      {
        icon: <GradientIcon Icon={BellAlertIcon} />,
        title: "Fire Alarm & Public Address Systems",
        desc: "Integrated safety systems for emergency response and public communication.",
      },
    ],
  },
];

export default function Services() {
  return (
    <div className="bg-white text-gray-900">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#201C59] to-indigo-700 text-white py-24 px-6 md:px-20 text-center rounded-b-[70px] shadow-lg">
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-5xl font-bold mb-6"
        >
          Our Services & Solutions
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="text-lg max-w-2xl mx-auto"
        >
          We provide innovative, reliable, and scalable technology solutions to
          empower organizations and ensure business continuity.
        </motion.p>
      </div>

      {/* Services Section */}
      <div className="py-16 px-6 md:px-20 space-y-16">
        {servicesData.map((section, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: i * 0.2 }}
            viewport={{ once: true }}
          >
            <h2 className="relative text-2xl font-semibold mb-6 pl-3">
              <span className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-yellow-400 to-[#201C59] rounded"></span>
              {section.category}
            </h2>
            <div className="grid md:grid-cols-3 gap-6">
              {section.items.map((item, j) => (
                <motion.div
                  key={j}
                  whileHover={{ scale: 1.05 }}
                  className="bg-gray-50 border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-lg transition flex flex-col gap-4"
                >
                  {item.icon}
                  <h3 className="text-lg font-bold text-[#201C59]">
                    {item.title}
                  </h3>
                  <p className="text-gray-600">{item.desc}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
